import ContextualMenu from './ContextualMenu';
import { ContextualMenuProps, ContextualMenuValueProps } from './types';

export type { ContextualMenuProps, ContextualMenuValueProps };
export default ContextualMenu;
